import styled from "@emotion/styled";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  height: 100%;
  padding-top: 10px;

  .divider {
    display: flex;
    flex-direction: column;
    gap: 20px;
    height: 100%;
  }

  .content {
    display: flex;
    flex-direction: column;
  }

  .buttons {
    display: flex;
    flex-direction: row;
    gap: 15px;
  }

  button {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    background: #fff;
    color: #14223b;
    border-radius: 6px;
    border: 1px solid #ced4da;
    padding: 10px 12px;
    width: 50%;
    font-weight: 600;
    gap: 10px;
  }

  .no-hover-button:hover {
    background: inherit;
    color: inherit;
    border-color: inherit;
    box-shadow: none;
    border: 1px solid #ced4da;
  }
`;
